import { render, staticRenderFns } from "./EticaretteyimIcon.vue?vue&type=template&id=24a01970&scoped=true"
import script from "./EticaretteyimIcon.vue?vue&type=script&lang=js"
export * from "./EticaretteyimIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a01970",
  null
  
)

export default component.exports